export enum ServiceType {
  R10 = 'R10',
  EmeraldSellingService = 'EMERALD_SELLING_SERVICE',
}
